/**
 * Constants that define the type of gradient on text.
 * @static
 * @memberof PIXI
 * @type {object}
 */
export enum TEXT_GRADIENT
// eslint-disable-next-line @typescript-eslint/indent
{
    /**
     * Vertical gradient
     * @default 0
     */
    LINEAR_VERTICAL = 0,
    /**
     * Linear gradient
     * @default 1
     */
    LINEAR_HORIZONTAL = 1
}
